module.exports = __webpack_public_path__ + "static/media/pathi.32b59835.ogg";